import $ from 'jquery';

class Search {
  // 1. describe and create/initiate object
  constructor() {
    this.addSearchHTML();
    this.resultsDiv = $(".search-overlay__results");
    this.openButton = $(".mars-header__search-trigger");
    this.closeButton = $(".search-overlay__close");
    this.searchOverlay = $(".global-search-overlay");
    this.searchField = $("#search-term");
    this.searchForm = $("#search-form");
    this.events();
    this.isOverlayOpen = false;
    this.isSpinnerVisible = false;
    this.previousValue;
    this.typingTimer;
  }

  // 2. events
  events() {
    $(document).on("click", ".mars-header__search-trigger", this.openOverlay.bind(this));
    this.closeButton.on("click", this.closeOverlay.bind(this));
    $(document).on("keydown", this.keyPressDispatcher.bind(this));
    this.searchField.on("keyup", this.typingLogic.bind(this));

    let eTrigSearch = $.Event('keydown');
    eTrigSearch.which = 13;
    $('.mars-header__search-trigger').trigger(eTrigSearch);

    $(document).on("keydown", ".mars-header__search-trigger", function (e) {
      this.isOverlayOpen = false;
      if (e.keyCode === 13 && !this.isOverlayOpen) {
        $(".global-search-overlay").addClass("search-overlay--active");
        $("body").addClass("body-no-scroll");
        $(".global-search-overlay").val('');
        setTimeout(() => $(".global-search-overlay").focus(), 301);
        this.isOverlayOpen = true;
      }
      if (e.keyCode === 27 && this.isOverlayOpen) {
        $(".global-search-overlay").removeClass("search-overlay--active");
        $("body").removeClass("body-no-scroll");
        this.isOverlayOpen = false;
      }
    });

    $(document).on("keydown", function (eTrigClose) {
      if (eTrigClose.keyCode === 27) {
        $(".global-search-overlay").removeClass("search-overlay--active");
        $("body").removeClass("body-no-scroll");
        this.isOverlayOpen = false;
      }
    });


    /*$(document).on("click", ".mars-search-trigger", function () {
      $(".global-search-overlay").addClass("search-overlay--active");
      $("body").addClass("body-no-scroll");
      $("#search-term").val('');
      setTimeout(() => $("#search-term").focus(), 301);
      this.isOverlayOpen = true;
    });
    $(document).on("click", ".search-overlay__close", function () {
      $(".global-search-overlay").removeClass("search-overlay--active");
      $("body").removeClass("body-no-scroll");
      this.isOverlayOpen = false;
    });*/

    let vm = this;
    this.searchForm.on("submit", function (e) {
      window.location.href = "/search/" + vm.searchField.val();
      // e.preventDefault;
      return false;
    });

  }

  // 3. methods (function, action...)
  typingLogic() {
    if (this.searchField.val() != this.previousValue) {
      clearTimeout(this.typingTimer);

      if (this.searchField.val() && this.searchField.val().length > 2) {
        if (!this.isSpinnerVisible) {
          $('.search-overlay__more-link').remove();
          this.resultsDiv.html(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
          this.isSpinnerVisible = true;
        }
        this.typingTimer = setTimeout(this.getResults.bind(this), 750);
      } else {
        this.resultsDiv.html('');
        $('.search-overlay__more-link').remove();
        this.isSpinnerVisible = false;
      }
    }

    this.previousValue = this.searchField.val();
  }

  getResults() {
    $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/search?term=' + this.searchField.val() + '&number=-1&language=' + MaRS_DATA.lang, (results) => {
      this.resultsDiv.html(`
        <div class="row">
          <div class="col-12 col-md-6">
            <h3 class="search-overlay__section-title">${MaRS_DATA.lang == 'en' ? 'Are you looking for...' : 'Est-ce que vous recherchez...'}</h3>
            ${results.generalInfo.length ? '<ul class="link-list min-list">' : `<p class="no-info">${MaRS_DATA.lang == 'en' ? 'No general information matches that search.' : 'Aucun résultat ne correspond à cette recherche.'} </p>`}
              ${results.generalInfo.slice(0, 4).map(item => `<li data-enter="fade" data-enter-delay="0"><a href="${item.permalink}" title="${item.title}">${item.title}</a></li>`).join('')}
            ${results.generalInfo.length ? '</ul>' : ''}
          </div>
          <div class="col-12 col-md-6">
            <h3 class="search-overlay__section-title">${MaRS_DATA.lang == 'en' ? 'Challenges' : 'Défis'} (${results.challenges.length})</h3>
            ${results.challenges.length ? '<ul class="link-list min-list">' : `<p class="no-info">${MaRS_DATA.lang == 'en' ? 'No challenges match that search' : 'Aucun défi ne correspond à cette recherche'}. <a href="${MaRS_DATA.site_url}/challenges" title="${MaRS_DATA.lang == 'en' ? 'View all challenges' : 'Afficher tous les défis'}">${MaRS_DATA.lang == 'en' ? 'View all challenges' : 'Afficher tous les défis'}</a></p>`}
              ${results.challenges.length ? results.challenges.slice(0, 4).map(item => `<li data-enter="fade" data-enter-delay="0"><a href="${item.permalink}" title="${item.title}">${item.title}</a></li>`).join('') : ''}
            ${results.challenges.length ? '</ul>' : ''}
          </div>
        
        </div>
      `);

      $('.search-overlay__more-link').remove();
      this.resultsDiv.after(`<a class="search-overlay__more-link" href="${MaRS_DATA.lang == 'fr' ? '/fr' : ''}/search/${this.searchField.val()}" title="${MaRS_DATA.lang == 'en' ? 'See all results' : 'Afficher tous les résultats'}">${MaRS_DATA.lang == 'en' ? 'See all results' : 'Afficher tous les résultats'}</a>`);

      this.isSpinnerVisible = false;
    }).fail(function (jqXHR, textStatus, error) {
    });
  }

  keyPressDispatcher(e) {
    if (e.keyCode === 83 && !this.isOverlayOpen && !$("input, textarea").is(':focus')) {
      this.openOverlay();
    }

    if (e.keyCode === 13 && this.isOverlayOpen) {
      window.location.href = "/search/" + this.searchField.val();
    }

    if (e.keyCode === 27 && this.isOverlayOpen) {
      this.closeOverlay();
    }
  }

  openOverlay() {
    this.searchOverlay.addClass("search-overlay--active");
    $("body").addClass("body-no-scroll");
    this.searchField.val('');
    setTimeout(() => this.searchField.focus(), 301);
    this.isOverlayOpen = true;
  }

  closeOverlay() {
    this.searchOverlay.removeClass("search-overlay--active");
    $("body").removeClass("body-no-scroll");
    this.isOverlayOpen = false;
  }

  addSearchHTML() {
    $("body").append(`
      <div class="global-search-overlay search-overlay">
        <div class="search-overlay__top">
          <div class="container search-overlay__container">
            <form method="post" action="#" id="search-form">
              <label class="hideLabel" for="search-term">Search</label>
              <input type="text" name="s" id="search-term" data-id="searching" class="search-overlay__search-box" placeholder="${MaRS_DATA.lang === 'fr' ? 'Que recherchez-vous?' : 'What are you looking for?'}" autocomplete="off">
              <i class="search-overlay__close" aria-hidden="true"></i>
            </form>
          </div>
        </div>
        
        <div class="container">
          <div class="search-overlay__results"></div>
        </div>

      </div>
    `);
  }

}

export default Search;